export default {
}



// WEBPACK FOOTER //
// src/store/views/link/ranking/getters.js